import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const MicrosoftIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 16 16"
         fill="none"
         {...props}
      >
         <path
            d="M16 8.72727H8.72727V16H16V8.72727Z"
            fill="#FEBA08"
         />
         <path
            d="M7.27273 8.72727H0V16H7.27273V8.72727Z"
            fill="#05A6F0"
         />
         <path
            d="M16 0H8.72727V7.27273H16V0Z"
            fill="#80BC06"
         />
         <path
            d="M7.27273 0H0V7.27273H7.27273V0Z"
            fill="#F25325"
         />
      </svg>
   )
}

export default MicrosoftIcon
